/**
 * Copyright IBM Corp. 2016, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

import React from 'react';

const IdPrefixContext = /*#__PURE__*/React.createContext(null);
function useIdPrefix() {
  return React.useContext(IdPrefixContext);
}

export { IdPrefixContext, useIdPrefix };
